<template>
    <div>
        <div class="dismissable-note" v-if="visible">
            <div class="content-wrapper">
                <slot></slot>
            </div>

            <a href="#" class="close-icon" @click.prevent="dismiss">
                <svg
                    width="14"
                    height="14"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.86736 6.00842L10.5172 2.35856C10.5781 2.30186 10.6269 2.23348 10.6608 2.15751C10.6945 2.08155 10.7128 1.99953 10.7143 1.91638C10.7157 1.83322 10.7005 1.75062 10.6693 1.67351C10.6381 1.59639 10.5918 1.52634 10.533 1.46753C10.4742 1.40872 10.4041 1.36236 10.327 1.33121C10.2499 1.30006 10.1672 1.28476 10.0841 1.28623C10.0009 1.28769 9.91891 1.3059 9.84297 1.33975C9.76702 1.3736 9.69862 1.4224 9.64188 1.48325L5.99206 5.13311L2.3422 1.48325C2.22479 1.37385 2.06951 1.3143 1.90906 1.31713C1.74862 1.31996 1.59554 1.38495 1.48206 1.49842C1.36859 1.6119 1.3036 1.76498 1.30077 1.92543C1.29794 2.08587 1.35749 2.24115 1.46689 2.35856L5.11675 6.00842L1.46689 9.65828C1.35091 9.77442 1.28577 9.93179 1.28577 10.0959C1.28577 10.2601 1.35091 10.4174 1.46689 10.5336C1.58302 10.6496 1.74042 10.7147 1.90454 10.7147C2.06866 10.7147 2.22607 10.6496 2.3422 10.5336L5.99206 6.88372L9.64188 10.5336C9.75802 10.6496 9.91548 10.7147 10.0795 10.7147C10.2437 10.7147 10.4011 10.6496 10.5172 10.5336C10.6332 10.4174 10.6983 10.2601 10.6983 10.0959C10.6983 9.93179 10.6332 9.77442 10.5172 9.65828L6.86736 6.00842Z"
                        fill="#8D8B88"
                    />
                </svg>
            </a>
        </div>
    </div>
</template>

<script>
import { getCookieValue, setCookie } from "@/utilities/cookies";

export default {
    name: "DismissableNote",
    props: {
        cookie: String,
        cookieDuration: String,
    },
    data() {
        return {
            visible: false,
        };
    },
    mounted() {
        if (this.cookie && getCookieValue(this.cookie) !== "false") {
            this.visible = true;
        }
    },
    methods: {
        dismiss() {
            let days = parseInt(this.cookieDuration || 365);

            setCookie(this.cookie, "false", days);

            this.visible = false;
        },
    },
};
</script>

<style scoped lang="scss">
.dismissable-note {
    color: #212529;
    background-color: #f8f6f3;
    padding: 1rem;
    margin: 1rem 0;
    position: relative;
}

.content-wrapper {
    text-align: center;
    padding: 0 1.5rem;
}

.close-icon {
    position: absolute;
    top: 0.5rem;
    right: 0.75rem;
}
</style>
